export default "__VITE_ASSET__BmarDXbx__"